export const externalLinks = {
  utm: {
    source: 'VolunteerCenter',
    campaign: 'MLP',
  },
  volunteeringGrants: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/Grants/',
  attendance: {
    becomeAmbassador:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/BecomeACommunityAmbassador/',
    workdocs:
      'https://amazon.awsapps.com/workdocs-amazon/index.html#/folder/96bc12d73ade87046b612bce18be243f3747fd659a2cf288bd41252ad2a31ed9',
  },
  myActivity: {
    search: 'https://www.volunteercenter.amazon.dev/',
    wiki: {
      planEvent: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/PlanAnEvent',
      manageEvent:
        'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/ManageYourEvent',
      amazonVolunteering: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering',
      playbooks:
        'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/VolunteeringPlaybooks',
    },
    givehub: {
      charitableOrgs: 'https://amazon.benevity.org/search/causes/list',
    },
    training: {
      coordinatorTraining: 'https://atoz.amazon.work/learn/trainings/CRSKN1T201908301943090c891045',
    },
    dashboard: {
      eventSearch:
        'https://us-east-1.quicksight.aws.amazon.com/sn/account/amazonbi/dashboards/a8690998-94a5-4053-9f51-8aa0c28e5a3c/sheets/a8690998-94a5-4053-9f51-8aa0c28e5a3c_2677723d-6bec-47d5-89b2-5f6b5f776995',
    },
  },
  moreWays: {
    planEvent:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/Volunteering/PlanningaVolunteerEvent/',
    plugAndPlay:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/Volunteering/PlanningintheUS/#HPlugandPlay',
    assistedPlanning:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/Volunteering/PlanningintheUS/#HAssistedPlanning',
  },
  support: {
    becomeAmbassador:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/BecomeACommunityAmbassador/',
    documentation:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Tech/VolunteerCenter/UserGuide/',
    feature: 'https://sim.amazon.com/issues/create?template=4e30685d-c924-4864-b400-adfa8f86a9a1',
    whatsNewFeedback:
      'https://sim.amazon.com/issues/create?template=ac373807-1eeb-4678-ab10-bae932220346',
    contact:
      'https://river.amazon.com/workflow/run/wfss-de13faab-7604-4231-be3d-bee7ed112b09?buildingType=ACI',
    whoCanAccess:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Data/Projects/VolunteeringDataProducts/VolunteerCenter/FAQs#HWhohasaccesstoVolunteerCenter3F',
    givehubTutorials: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/GIVEhub/Tutorials/',
    aciWiki: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering',
    vcWiki: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/VolunteerCenter',
    planningPlaybooks:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/PlanAnEvent',
    training:
      'https://knet.csod.com/ui/lms-learning-details/app/curriculum/31929310-981f-425f-8688-e1ea1b2ddf3a',
    a2z: 'https://news.a2z.com/channels/1303470',
    hiring: 'https://amazon.jobs/content/en/internal/teams/ccr/aci',
    trackTime: 'https://amazon.benevity.org/volunteer/external/track',
    faqs: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/FAQs/',
    question:
      'https://river.amazon.com/LHR16/workflows?buildingType=ACI&q0=e15964d7-3055-4332-ae26-6f2391ec4e65&id=e15964d7-3055-4332-ae26-6f2391ec4e65',
    ticket: 'https://t.corp.amazon.com/create/templates/132ba58d-4ce0-41d9-8d45-5d2e5169f225',
  },
  benevity: {
    trackTime: 'https://amazon.benevity.org/volunteer/external/track',
    event: 'https://amazon.benevity.org/volunteer/',
    editEvent: 'https://amazon.benevity.org/volunteer/{id}/edit',
    manageSignups: 'https://amazon.benevity.org/volunteer/{id}/manage/signups',
    manageTime: 'https://amazon.benevity.org/volunteer/{id}/manage/submissions',
    bulkEmail: 'https://amazon.benevity.org/adm/bulk_email/create?node_id={id}',
    signup: 'https://amazon.benevity.org/volunteer/signup/',
  },
  bulkUpload: {
    bulkUpdateInstructions:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Tech/Hack-A-Thons/2023-Q4/BulkGIVEhubUpdates/#HUserGuide',
    bulkUpdateTroubleshooting:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Tech/Hack-A-Thons/2023-Q4/BulkGIVEhubUpdates/#HTroubleshooting',
    accessRequest:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Tech/Operations/TicketTemplates/#HBugReports',
  },
  events: {
    coordinatorNotificationUserGuide:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Data/Projects/VolunteeringDataProducts/VolunteerCenter/UserGuide/Notifications-Coordinator/',
  },
  sideNav: {
    searchNonprofits: 'https://amazon.benevity.org/search/causes/list/?page=1&query=*',
    userGuides:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Data/Projects/VolunteeringDataProducts/VolunteerCenter/UserGuide',
    planEvent: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/PlanAnEvent',
    fundingSupport: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/Grants/',
    acivDashboard:
      'https://us-east-1.quicksight.aws.amazon.com/sn/account/amazonbi/dashboards/a8690998-94a5-4053-9f51-8aa0c28e5a3c/sheets/a8690998-94a5-4053-9f51-8aa0c28e5a3c_2677723d-6bec-47d5-89b2-5f6b5f776995',
    vcWiki:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Data/Projects/VolunteeringDataProducts/VolunteerCenter/',
    aciWiki: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering',
    a2zNews: 'https://atoz.amazon.work/feed/topics/7b398df8-7358-4ea1-59cb-ea23180fc859',
    newsletter: 'https://list.email.amazon.dev/lists/volunteer-center-interest@amazon.com',
  },
};
